<template>
  <div class="module-container">
    <div class="module-header">
      <div class="module-title" style="font-weight: bolder;">
        <span>双重预防机制管理</span>
      </div>
      <span class="more-link" @click="goToRiskLedgerStatistics">查看更多</span>
    </div>
    <div class="module-content">
      <div class="disaster-grid">
        <div v-for="(item, index) in disasterData" :key="index" class="disaster-item" :class="item.level">
          <div class="disaster-icon"></div>
          <div class="disaster-label">{{ item.label }}</div>
          <div class="disaster-count" :title="item.count">{{ item.count }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRiskPointByLevel } from "@/api/safetyPrevention/reportAnalysis";
export default {
  name: 'DisasterPreventionManagement',
  data() {
    return {
      disasterData: [
        { label: '重大风险', count: '0', level: 'severe' },
        { label: '较大风险', count: '0', level: 'high' },
        { label: '一般风险', count: '0', level: 'medium' },
        { label: '低风险', count: '0', level: 'low' }
      ],
      refreshInterval: null
    }
  },
  mounted() {
    this.fetchDisasterData();
    // 设置定时刷新，每30分钟刷新一次
    this.refreshInterval = setInterval(this.fetchDisasterData, 1800000)
  },
  beforeDestroy() {
    // 清除定时器，避免内存泄漏
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  methods: {
    async fetchDisasterData() {
      // 先清空数据，确保即使数据不变也能触发重新渲染
      this.disasterData = [
        { label: '重大风险', count: '0', level: 'severe' },
        { label: '较大风险', count: '0', level: 'high' },
        { label: '一般风险', count: '0', level: 'medium' },
        { label: '低风险', count: '0', level: 'low' }
      ]
      const result = await getRiskPointByLevel({});
      // 转换数据格式并更新disasterData
      const riskData = Object.entries(result.data).map(([name, count]) => ({
        name,
        count
      }));

      // 更新对应风险等级的计数
      riskData.forEach(item => {
        if (item.name === '重大风险') {
          this.disasterData[0].count = item.count.toString();
        } else if (item.name === '较大风险') {
          this.disasterData[1].count = item.count.toString();
        } else if (item.name === '一般风险') {
          this.disasterData[2].count = item.count.toString();
        } else if (item.name === '低风险') {
          this.disasterData[3].count = item.count.toString();
        }
      });

    },
    goToRiskLedgerStatistics() {
      // 获取用户权限
      const userRoles = JSON.parse(decodeURI(window.localStorage.userRoles))

      // 检查是否有风险点查询权限
      if (userRoles && userRoles.includes('pre_fengxiandianweichaxun')) {
        // 有权限，跳转到风险点查询
        this.$router.push('/safetyPrevention/riskControlLedger/riskPointQuery');
      } else {
        // 无权限，提示
        this.$message({
          type: 'warning',
          message: '您暂无权限访问'
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.module-container {
  display: flex;
  flex-direction: column;
}

.module-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.module-title {
  font-family: Source Han Sans CN;
  font-weight: 800;
  font-size: 19px;
  color: #FFFFFF;
  width: 430px;
  height: 35px;
  color: #fff;
  text-align: center;
  background: url("/static/image/equip/shebeiyunxingzhuangtai-bg.png") no-repeat center;

  span {
    margin-left: -109px;
  }
}

.more-link {
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}

.more-link:hover {
  // 显示下划线
  text-decoration: underline;
}

.module-content {
  /* padding: 10px 0; */
  display: flex;
  flex-direction: column;
}

.disaster-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin: 15px 0;
}

.disaster-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}


.disaster-item.severe {
  color: #D35657;
}

.disaster-item.high {
  color: #F7E7A1;
}

.disaster-item.medium {
  color: #fff;
}

.disaster-item.low {
  color: #66B7BB;
}

.disaster-icon {
  width: 25px;
  height: 25px;
  background: url('/static/image/six/severe-risk.png') no-repeat center;
  background-size: contain;
  margin-right: 3px;
}

.disaster-label {
  font-size: 12px;
  margin-right: 5px;
}

.disaster-count {
  font-size: 19px;
  font-weight: bold;
  width: 38px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
